import React from 'react';
import { brands } from '../homeData';
import styles from './Brands.module.css';

const Brands = () => (
  <section className={styles.brandsInfoContainer}>
    {brands.map((brand) => (
      <div key={brand.id} className={styles.brandsCard}>
        <div className={styles.brandsImageContainer}>
          <img
            src={brand.image}
            alt={`Brand ${brand.id}`}
            className={styles.brandsImage}
          />
        </div>
        <div className={styles.brandsContent}>
          <ul>
            {brand.features.map((feat, i) => (
              <li key={i}>{feat}</li>
            ))}
          </ul>
        </div>
      </div>
    ))}
  </section>
);

export default React.memo(Brands);
